import { MARQUEE_TERMS } from "@/lib/constants";

export default function EditorialMarquee({ terms = MARQUEE_TERMS }) {
  const all = [...terms, ...terms, ...terms];
  return (
    <div data-testid="editorial-marquee" className="border-y border-black/10 py-5 overflow-hidden bg-[color:var(--np-bg-2)]">
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {all.map((t, i) => (
          <span key={i} className="font-mono-tech text-[11px] tracking-[0.35em] uppercase text-[color:var(--np-text-2)] mx-6 inline-flex items-center gap-6">
            {t}
            <span className="w-1 h-1 rounded-full bg-[color:var(--np-live)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
